import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import { DocumentService } from '../../../../services';
import * as moment from 'moment' ;
import { DOCUMENT_EDIT_DOCUMENT, DOCUMENT_INIT_DOCUMENT_SELECTION, DOCUMENT_MODULE_NAMESPACE, DOCUMENT_REMOVE_DOCUMENT, DOCUMENT_SET_DOCUMENT, DOCUMENT_SET_DOCUMENTS, DOCUMENT_SET_DOCUMENT_ACTION, DOCUMENT_SET_DOCUMENT_PARAMETER, DOCUMENT_SET_DOCUMENT_SELECTION, EQUIPMENT_EDIT_DOCUMENT } from '../../../../store/document';
import { IDocumentListingViewmodel, IDocumentParamter } from '../../../../models/documents';
import { namespace } from 'vuex-class';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { IUserDetails } from '../../../../models/user';
import { CrudStatus } from '../../../../common/enums';
import { eventBus } from '../../../../main';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../../store/service-book';
import { IServiceBookDetails } from '../../../../store/service-book/service-book-state.store';


const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

@Component({
  components: {
  },
  filters: {
    date_format(date: string) {
      return moment(date).format("DD/MM/YYYY")
    },
    attachment_type(name: string) {
      if (!name) return ''
      const res = name.split('.')
      if (res && res[res.length-1]) return res[res.length-1]
      return ''
    }
  }
})

class BlockEquipmentDocuments extends Vue {

  @Prop({ required: true, type: [String] })
  equipmentId: string;

  @Prop({ required: true, type: [String] })
  equipmentName: string;


  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails

  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => Promise<any>

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
  storeSetDocumentParameter: (payload: IDocumentParamter) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT)
  storeSetDocument: (payload?: any) => void

  @DocumentStore.Action(EQUIPMENT_EDIT_DOCUMENT)
  storeEditDocument: (doc: any) => void

  @DocumentStore.Getter documentCrudActionStatus: CrudStatus

  @UserStore.Getter userInfo: IUserDetails

  @DocumentStore.Mutation(DOCUMENT_INIT_DOCUMENT_SELECTION)
  storeInitDocumentSelection: () => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_ACTION)
  storeSetDocumentAction: (status: CrudStatus) => void

  @DocumentStore.Getter documentSelection: number[]
  @DocumentStore.Getter documentTypes: any[]

  @DocumentStore.Action(DOCUMENT_REMOVE_DOCUMENT)
  storeRemoveDocument: () => Promise<any>

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_SELECTION)
  storeSetDocumentSelection: (id: number) => void



  documentService:DocumentService
  headers:any[]
  loading: boolean
  totalDocuments: number
  documents:any[]
  dtAttributeItem: number
  dtDocMenu: {
    active: boolean,
    x: number,
    y: number,
    item: any
  }
  dtIsLoading: boolean

  constructor() {
    super()
    this.documentService = new DocumentService()
    this.dtIsLoading = false
    this.totalDocuments = 0
    this.documents = []
    this.loading = true
    this.dtAttributeItem = -1
    this.dtDocMenu = {
      active: false,
      x: 0,
      y: 0,
      item: null
    }
    this.headers=[
      /* { text: 'Nom du fichier', value: 'name', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: 'Ajouté le', value: 'createdAt', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: 'Ajouté par', value: 'creator_name', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: '', value: 'link', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' }, */
    ]
  }

  mounted(){
    this.loading = true
    this.getDocuments().then(response=>{
      console.log('lastDocs = ',response)
      this.totalDocuments = response.length
      this.documents = response
      this.loading = false
    })
  }

  get lblSetting() {
    return {
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/document').default
    }
  }

  get coHeaders() {
    return [
      {
        //text: 'avatar',
        value: 'avatar',
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.document_headers.filename),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.document_headers.addedAt),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.document_headers.addedBy),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        value: 'modifier & supprimer',
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title hidden'
      }
    ]
  }

  get coDocumentDelectionMessage() {
    if (this.documentSelection.length === 1)
      return this.$t(this.lblSetting.documentDeleteMessage, {name: (this.documents.find(document => document.id === this.documentSelection[0]) as any).name})
    else if (this.documentSelection.length > 1) return this.$t(this.lblSetting.documentDeleteSelectionMessage)
    return ""
  }

  handleDeleteDocumentCancel() {
    this.storeInitDocumentSelection()
    this.storeSetDocumentAction(CrudStatus.NoAction)
  }

  handleDeleteDocumentOK() {
    this.dtIsLoading = true

    this.storeRemoveDocument()
      .then(response => {
        eventBus.$emit('RELOAD_BLOCK_DASHBORD',this.$route.params.id)
        eventBus.$emit('RELOAD_ON_DELETE_LAST_DOC')
      })
      .catch(err => {
        //this.dtMessageErrorModel = true
        //this.dtError = err
        console.log(err)
      })
      .finally(() => {
        this.dtIsLoading = false
        //this.storeSetLoaderState({ key: DOCUMENT_LOADERS.TABLE_LOADER, value: false })
      })
  }

  get isServiceBook():boolean {
    return this.$route.path.includes('service-book')
  }

  async getDocuments():Promise<any[]>
  {
    let blockId = 0
    let apartment = 0
    if(this.isServiceBook)
    {
      if(!this.currentServiceBook.apartment) {
        await this.storeGetServiceBook(this.$route.params.id)
        blockId = this.currentServiceBook.apartment.fk_apartment_block
        apartment = this.currentServiceBook.apartment.id
      } else {
        blockId = this.currentServiceBook.apartment.fk_apartment_block
        apartment = this.currentServiceBook.apartment.id
      }
    }
    else {
      blockId = parseInt(this.$route.params.id)
      apartment = null
    }

    //let blockId = this.$route.params.id
    const params = {
      $skip:0,
      $limit:5,
      detail:true,
      orderKeys:['updatedAt','createdAt'],
      orderValues:[-1,-1],
      block:blockId,
      equipment:[this.equipmentId],
      apartment:apartment?apartment:null
    }



    try {
      let response = await this.documentService.getDocumentAttachments(params)
      return response.data
    } catch (error) {
      console.log(error)
      return []
    }
  }

  goToDocuments()
  {
    let id = this.$route.params.id
    //let cid = this.equipmentId
    this.storeSetDocumentParameter({equipment:[parseInt(this.equipmentId)]})
    if(this.isServiceBook)
    {
      this.$router.push(`/service-book/${this.$route.params.id}/documents`)
    } else {
      this.$router.push({ name: 'block_documents', params: { id, equipmentId:this.equipmentId, equipmentName:this.equipmentName } })
    }

  }

  handleClickDoc(item) {
    console.log('Click Doc', item)
    window.open(item.link)
    // this.$router.push({path: `${this.$route.params.id}/detail/${item.id}`})
  }

  handleShowMore (e, item) {
    if (this.dtAttributeItem === item.id)
      this.dtAttributeItem = -1
    else this.dtAttributeItem = item.id
  }

  handleShowMenu (e, item) {
    // e.preventDefault()
    this.dtDocMenu.x = e.clientX
    this.dtDocMenu.y = e.clientY
    this.$nextTick(() => {
      this.dtDocMenu.active = true
      this.dtDocMenu.item = item
    })
  }

  canManageDocument(entity_id): boolean {
    return this.userInfo.id === entity_id || this.$route.meta['manage_agency_document']
  }

  handleEditDocument(doc:any) {
    this.storeSetDocument(doc)
    this.storeEditDocument(doc)
    console.log('edit ', doc)
    this.$emit('update-doc-by-id')


  }

  handleShareDoc () {
    if (this.dtDocMenu.item) {
      let url = `mailto:${this.userInfo.email}?body=${this.dtDocMenu.item.link}`
      window.open(url, '_blank').focus();
    }
  }

  handleDeleteDocument(id: number) {
    this.storeInitDocumentSelection()
    this.storeSetDocumentSelection(id)
    this.storeSetDocumentAction(CrudStatus.Delete)
    console.log('delete ', id)
  }

  get isOpenDeleteMessage() {
    return this.documentCrudActionStatus === CrudStatus.Delete
  }
}



export default BlockEquipmentDocuments




// WEBPACK FOOTER //
// ./src/containers/block/components/block-equipment-documents/index.ts